<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div *ngIf="naviPath ==='centers'" class="flex flex-row mb-4 mr-5 ml-0 gap-5 cursor-pointer">
        <p class="font-semibold text-sm text-[#424242] dark:text-white" (click)="navigateToCenters()">Centres</p>
        <p class="font-semibold text-sm text-[#424242] dark:text-white" (click)="navigateToCenterDashboard()">Centre
            Dashboard</p>
        <p class="font-semibold text-sm text-[#424242] dark:text-white" onclick="history.back()">Centre Officers</p>
        <p class="font-semibold text-sm text-[#424242] dark:text-white">Officer Profile</p>
    </div>

    <div *ngIf="naviPath ==='manage-officers'"
        class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
        <p onclick="history.back()">Manage Officers</p>
        <p>Officer Profile</p>
    </div>

    <div *ngIf="naviPath ==='distribution-officers'"
        class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
        <p onclick="history.back()">Manage Officers</p>
        <p>Officer Profile</p>
    </div>

    <div *ngIf="naviPath ==='distribution-center'"
        class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
        <p onclick="history.back()">Distribution Centres</p>
        <p onclick="history.back()">Center Dashboard</p>
        <p>Officer Profile</p>
    </div>

    <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-white shadow-lg rounded-lg">
        <div class="flex flex-col gap-7 px-2 py-2" id="reportcontainer">
            <div
                class="flex flex-row justify-between items-center border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <div class="flex flex-row items-center">
                    
                    <div *ngIf="officerObj.image"> 
                        <img class="w-28 h-28 rounded-full object-cover" [src]="officerObj.image" />
                    </div>

                    <div *ngIf="!officerObj.image" 
                            class="flex rounded-full border-solid border-2 justify-center items-center w-32 h-32">
                            <i class="fa-regular fa-user text-6xl dark:text-white"></i>
                        </div>

                    <div class="ml-6">
                        <p class="text-lg font-semibold">{{officerObj.firstNameEnglish}} {{officerObj.lastNameEnglish}}
                        </p>
                        <p class="text-[#627189] dark:text-textDark"><ng-container
                                *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver; else roleLabel">Driver</ng-container><ng-template
                                #roleLabel>{{officerObj.jobRole}}</ng-template> - <span
                                class="text-black font-semibold dark:text-white">
                                <span *ngIf="officerObj.jobRole ==='Customer Officer'">CUO</span>
                                <span *ngIf="officerObj.jobRole ==='Collection Centre Manager'">CCM</span>
                                <span *ngIf="officerObj.jobRole ==='Collection Centre Head'">CCH</span>
                                <span *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver">DRV</span>
                                <span *ngIf="officerObj.jobRole ==='Collection Officer'">COO</span>
                                <span *ngIf="officerObj.jobRole ==='Distribution Officer'">DIO</span>
                                <span *ngIf="officerObj.jobRole ==='Distribution Centre Manager'">DCM</span>
                                <span *ngIf="officerObj.jobRole ==='Distribution Centre Head'">DCH</span>{{officerObj.empId}} <span *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver">  |  {{officerObj.jobRole}}  |  {{officerObj.slvCatName}}</span>
                            </span>
                        </p>
                        <p class="font-semibold" *ngIf="officerObj.jobRole === 'Collection Centre Manager' 
                            || officerObj.jobRole === 'Collection Centre Head' 
                            || officerObj.jobRole === 'Collection Officer' 
                            || officerObj.jobRole === 'Customer Officer'">
                            {{ officerObj.regCode ? officerObj.regCode + ' Centre' : 'Officer has been disclaimed - No Assigned Centre' }}
                        </p>

                        <p class="font-semibold" *ngIf="officerObj.jobRole === 'Distribution Centre Manager' 
                            || officerObj.jobRole === 'Distribution Centre Head' 
                            || officerObj.jobRole === 'Distribution Officer'
                            || officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver">
                            {{ officerObj.distributedCenterRegCode ? officerObj.distributedCenterRegCode + ' Centre' : 'Officer has been disclaimed - No Assigned Centre' }}
                        </p>
                        <p class="text-[#627189] dark:text-textDark">{{officerObj.companyNameEnglish}}</p>
                    </div>
                </div>

                <div class="flex space-x-4">
                    <span
                        *ngIf="(logingRole === 'Collection Centre Manager' && officerObj.jobRole !=='Collection Centre Manager' && officerObj.claimStatus === 1 ) || (logingRole === 'Distribution Centre Manager' && officerObj.jobRole !=='Distribution Centre Manager' && officerObj.claimStatus === 1 ) ">
                        <button class="bg-[#E20000] text-white font-semibold rounded-lg shadow-md px-5 py-2"
                            (click)="toggleDisclaimView()">Disclaim</button>
                    </span>
                    <button *ngIf="(logingRole === 'Collection Centre Manager' || logingRole === 'Collection Centre Head')" class="bg-blue-600 text-white font-semibold rounded-lg shadow-md px-5 py-2"
                        (click)="viewOfficerTarget(officerId, officerObj.centerName)">View Target</button>
                    <!-- <button *ngIf="(logingRole === 'Distribution Centre Manager' || logingRole === 'Distribution Centre Head') && (officerObj.jobRole === 'Distribution Centre Manager' || officerObj.jobRole === 'Distribution Officer') && officerObj.distributedCenterRegCode" class="bg-blue-600 text-white font-semibold rounded-lg shadow-md px-5 py-2"
                        (click)="viewOfficerTargetDistribution(officerId, officerObj.distributedCenterName, officerObj.distributedCenterId, officerObj.empIdPrefix)">View Target</button> -->
                </div>

            </div>

            <div class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <div class="flex flex-row justify-between">
                    <p class="font-semibold">Personal Infomation</p>
                    <button class="bg-[#415CFF] text-white px-6 py-1 text-xl rounded-lg shadow-md"
                        (click)="generatePDF()">
                        <i class="fa-solid fa-download"></i>
                    </button>
                </div>

                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">First Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.firstNameEnglish}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Last Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.lastNameEnglish}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">NIC Number</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.nic}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Email</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.email}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Mobile Number - 1 </p>
                        <p class="font-semibold dark:text-white text-black">{{ officerObj.phoneNumber01 ?
                            officerObj.phoneCode01 + officerObj.phoneNumber01 : ' - ' }}
                        </p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Mobile Number - 2</p>
                        <!-- <p class="font-semibold">{{officerObj.phoneCode02}}{{officerObj.phoneNumber02}}</p> -->
                        <p class="font-semibold dark:text-white text-black">
                            {{ officerObj.phoneNumber02 ? officerObj.phoneCode02 + officerObj.phoneNumber02 : ' - ' }}
                        </p>
                    </div>

                </div>

            </div>

            <div class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <p class="font-semibold">Address Details</p>


                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">House / Plot Number</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.houseNumber}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Street Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.streetName}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">City</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.city}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Country</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.country}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Province</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.province}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">District</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.district}}</p>
                    </div>

                </div>

            </div>

            <div class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <p class="font-semibold">Bank Details</p>


                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">Account Holder’s Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.accHolderName}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Account Number</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.accNumber}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Bank Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.bankName}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Branch Name</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.branchName}}</p>
                    </div>

                </div>

            </div>


            <div *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver" class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <p class="font-semibold">Driving Details</p>


                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">Driving License ID</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.licNo}}</p>
                    </div>

                    <div>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">License's Front Image</p>
                        <a [href]="officerObj.licFrontImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">License's Back Image</p>
                        <a [href]="officerObj.licBackImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                </div>

            </div>


            <div *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver" class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <p class="font-semibold">Vehicle Insurance Details</p>


                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle Insurance Number</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.insNo}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Insurance Expire Date</p>
                        <p class="font-semibold dark:text-white text-black">
                          {{ officerObj.insExpDate | date:'yyyy-MM-dd' }}
                        </p>
                      </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Insurance's Front Image</p>
                        <a [href]="officerObj.insFrontImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Insurance's Back Image</p>
                        <a [href]="officerObj.insBackImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                </div>

            </div>

            <div *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver" class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
                <p class="font-semibold">Vehicle Details</p>


                <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle Registration Number</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.vRegNo}}</p>
                    </div>

                    <div>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle Type</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.vType}}</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle Capacity</p>
                        <p class="font-semibold dark:text-white text-black">{{officerObj.vCapacity}}Kg</p>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle’s Front Image</p>
                        <a [href]="officerObj.vehFrontImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle’s Back Image</p>
                        <a [href]="officerObj.vehBackImg" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle’s Side Image - 1</p>
                        <a [href]="officerObj.vehSideImgA" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>

                    <div>
                        <p class="text-[#627189] dark:text-textDark">Vehicle’s Side Image - 2</p>
                        <a [href]="officerObj.vehSideImgB" target="_blank">
                            <i class="fa-solid fa-image text-3xl text-black"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showDisclaimView" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white dark:bg-[#363636] shadow-lg rounded-lg p-6 w-1/2">

            <div>
                <!-- Icon -->
                <div
                    class="flex items-center justify-center bg-[#F6F7F9] rounded-lg shadow-sm px-4 mb-3 py-3 mx-auto w-[70px]">
                    <i class="fa-solid fa-triangle-exclamation text-[#6B7D8C] text-4xl px-1"></i>
                </div>

                <div class="mb-4 text-center dark:text-textDark">
                    <p class="text-lg mb-2">
                        Are you sure you want to Disclaim the officer
                    </p>
                    <p class="font-semibold text-lg dark:text-white">
                        "{{officerObj.firstNameEnglish}} {{officerObj.lastNameEnglish}}" (EMP ID -
                        "{{officerObj.empIdPrefix}}")
                        <span class="font-normal">from centre</span> <br>
                        <span *ngIf="officerObj.jobRole ==='Collection Officer'">"{{officerObj.regCode}}"?</span>
                        <span *ngIf="officerObj.jobRole ==='Distribution Officer'">"{{officerObj.distributedCenterRegCode}}"?</span>
                        <span *ngIf="officerObj.jobRole === jobRoleTypes.lightWeightDriver || officerObj.jobRole === jobRoleTypes.heavyWeightDriver">"{{officerObj.distributedCenterRegCode}}"?</span>
                    </p>

                    <p class="text-red-500 mb-6 italic">
                        Please note that the officer will no longer be under your monitoring.
                    </p>
                </div>

                <!-- Buttons -->
                <div class="flex justify-center gap-4">
                    <button class="bg-[#E8E8E8] border-[1px] border-[#6B7D8C] px-10 py-0.35 rounded-lg shadow-md"
                        (click)="confirmDisclaim(officerId)"><span class="font-semibold text-[#6B7D8C]">Yes,</span> <br>
                        <span class="text-light text-whight-700 button-text text-[#6B7D8C]">Disclaim</span>
                    </button>
                    <button class="bg-[#415CFF] border-[1px] border-[#415CFF] px-10 py-0.35 rounded-lg shadow-md"
                        (click)="cancelDisclaim()"><span class="font-semibold text-white">No,</span> <br>
                        <span class="text-light text-whight-700 button-text text-white">Go Back</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>